var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-action-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle } },
        [
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
          _c(
            "ui-button",
            {
              attrs: {
                slot: "left",
                color: "medium",
                type: "bordered",
                to: _vm.backRoute,
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-date-input", {
            attrs: { title: "Datum", name: "date", rules: "required" },
            model: {
              value: _vm.pendingHarvest.date,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "date", $$v)
              },
              expression: "pendingHarvest.date",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              number: "",
              title: "Bruto",
              name: "brutoWeight",
              suffix: "mTon",
            },
            model: {
              value: _vm.pendingHarvest.brutoWeight,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "brutoWeight", $$v)
              },
              expression: "pendingHarvest.brutoWeight",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              number: "",
              title: "Netto",
              name: "nettoWeight",
              suffix: "mTon",
            },
            model: {
              value: _vm.pendingHarvest.nettoWeight,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "nettoWeight", $$v)
              },
              expression: "pendingHarvest.nettoWeight",
            },
          }),
          _c("ui-form-input", {
            attrs: { decimal: "", title: "Tarra", name: "tarra", suffix: "%" },
            model: {
              value: _vm.pendingHarvest.tarra,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "tarra", $$v)
              },
              expression: "pendingHarvest.tarra",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Bustal", name: "bustal" },
            model: {
              value: _vm.pendingHarvest.bustal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "bustal", $$v)
              },
              expression: "pendingHarvest.bustal",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Stukstal", name: "stukstal" },
            model: {
              value: _vm.pendingHarvest.stukstal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "stukstal", $$v)
              },
              expression: "pendingHarvest.stukstal",
            },
          }),
          _c("ui-form-switch", {
            attrs: { title: "Leeggevist", name: "emptied" },
            model: {
              value: _vm.pendingHarvest.emptied,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "emptied", $$v)
              },
              expression: "pendingHarvest.emptied",
            },
          }),
          _c("ui-form-textarea", {
            attrs: { title: "Bijzonderheden", name: "notes" },
            model: {
              value: _vm.pendingHarvest.notes,
              callback: function ($$v) {
                _vm.$set(_vm.pendingHarvest, "notes", $$v)
              },
              expression: "pendingHarvest.notes",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }